import React, { useMemo } from "react";
import { Background } from "styles/home";

const STAR_COUNT = 440;

export const BackgroundAnimation = () => {
  const starts = useMemo(() => {
    return Array.from({ length: STAR_COUNT }).map(() => {
      const x = Math.random() * window.innerWidth;
      const y = Math.random() * window.innerHeight;
      const dx = (Math.random() - 0.5) * 100;
      const dy = (Math.random() - 0.5) * 100;

      const duration = 10 + Math.random() + 10;

      return { x, y, dx, dy, duration };
    });
  }, []);
  return (
    <Background>
      {starts.map((star, i) => (
        <span
          key={i}
          className="star"
          style={{
            left: star.x,
            top: star.y,
            "--dx": `${star.dx}px`,
            "--dy": `${star.dy}px`,
            animationDuration: `${star.duration}s`,
          }}
        />
      ))}
    </Background>
  );
};
